const Spy = Symbol.for('react-wrap-with/Spy');

export default Spy;
